import React from "react";
import "./DotsLoader.scss";

export default function DotsLoader() {

  return (
    <span className="DotsLoader loading">...</span>
  );
};
